import * as React from 'react';
import '../Chat/app.scss';
import Navbar from 'react-bootstrap/Navbar';
import Nav from 'react-bootstrap/Nav';
import { Header } from '../Header';
import { Footer } from '../Footer';
import { Container } from '../Container';
import { MessageContainer } from '../../Containers/MessageContainer';
import { AuthContext } from '../../contexts/AuthContext';
import separator_ from '../../assets/images/separator.svg';
import * as LangConfig from '../../languages/languages';

import * as Config from '../../config';
import AWS from 'aws-sdk';
import { getSignedUrl } from "@aws-sdk/s3-request-presigner";
import { S3Client, GetObjectCommand, PutObjectCommand } from "@aws-sdk/client-s3";

import { makeStyles, createStyles, Theme } from '@material-ui/core/styles';
import Button from '@material-ui/core/Button';
import TextField from '@material-ui/core/TextField';
import Grid from "@material-ui/core/Grid";
import { RouteComponentProps, Redirect } from 'react-router-dom';
import { AdapterLink } from '../AdapterLink';
import Input from '@material-ui/core/Input';
import SimpleSnackbar from '../SimpleSnackbar';
import InputAdornment from '@material-ui/core/InputAdornment';
import IconButton from '@material-ui/core/IconButton';
import Visibility from '@material-ui/icons/Visibility';
import VisibilityOff from '@material-ui/icons/VisibilityOff';

import en from '../../languages/en.json';
import es from '../../languages/es.json';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    container: {
      display: 'flex',
      flexDirection: 'column',
      flexWrap: 'wrap',
    },
    img_logo: {
      width: 350,
      marginBottom: 10,
    },
    label: {
    	marginRight: theme.spacing(1),
    	marginTop: 10,
    },
    textField: {
      marginLeft: theme.spacing(1),
      marginRight: theme.spacing(1),
      marginTop: 20,
      display: 'block'
    },
    passField: {
    	marginLeft: theme.spacing(1),
		marginRight: theme.spacing(1),
		marginTop: 20,
		display: 'flex'
    },
    menu: {
      width: 200,
    },
    button: {
      margin: theme.spacing(1),
      marginTop: 20,
    },
    input: {
      display: 'none',
    },
  }),
);

export const Profile: React.FC = (props) => {
  let auth = React.useContext(AuthContext);
  const classes = useStyles();
  const [translations, setTranslations] = React.useState(auth['user']['attributes'].locale ? LangConfig.languages[auth['user']['attributes'].locale]['translations'] : LangConfig.languages['en']['translations']);
  const [loading, setLoading] = React.useState(false);
  const [pass, setPass] = React.useState(false);
  const [language, setLanguage] = React.useState(auth.user['attributes']['locale']);
  const [fileObject, setFileObject] = React.useState({'name' : ''});
  const [values, setValues] = React.useState({
    username: auth.user['attributes']['email'],
    oldpassword: '',
    newpassword: '',
    confirmpassword: '',
    lastName: '',
    firstName: auth.user['attributes']['given_name'],
    phone: auth.user['attributes']['phone_number'] ? auth.user['attributes']['phone_number'] : '',
    address: auth.user['attributes']['address'] ? auth.user['attributes']['address'] : '',
    photo: auth.user['attributes']['picture'] ? auth.user['attributes']['picture'] : '',
    errorMessages: [],
    successMessages: [],
    registerSuccess: false,
  });

  /*const validateForm = (values: any) => {
    let err: string = '';
    if(!values['firstName']) {
    	err = 'Please enter First Name.';
    } 
    else if(!values['phone']) {
    	err = 'Please enter First Name.';
    } 
    else if(!values['address']) {
    	err = 'Please enter First Name.';
    } 
    else if(!values['photo']) {
    	err = 'Please enter First Name.';
    } 
    else if(!values['firstName']) {
    	err = 'Please enter First Name.';
    } 
    else if(!values['firstName']) {
    	err = 'Please enter First Name.';
    } 
    else if(!values['firstName']) {
    	err = 'Please enter First Name.';
    }

    setValues({
      ...values,
      errorMessages: [...values.errorMessages, err]
    });

    return !!username && !!password;
  };
*/
  const inputOnKeyDown = (e: React.KeyboardEvent<HTMLFormElement>) => {
    if (e.keyCode === 13) {  // if "Enter"
      e.preventDefault();
      handleProfileUpdate();
    }
  };

  const handleProfileUpdate = async () => {
    setLoading(true)
    try {
		let username = values['username'].toLowerCase();
		let oldPassword = values['oldpassword'];
		let newPassword = values['newpassword'];
		let confirmpassword = values['confirmpassword'];
		let firstName = values['firstName'];
		let phone = values['phone'];
		let address = values['address'];
		let lastName = '';
		let photo = values['photo'];
		// const inputIsValid = validateForm(values);

		// if (inputIsValid) {
		setValues({
			...values,
			errorMessages: [],
			successMessages: []
		});

		if(fileObject.name != undefined && fileObject.name != '') {
			let imageUploaded = await uploadPhoto(fileObject);
			setValues({ ...values, photo: imageUploaded });
			photo = imageUploaded;
		}

		let result = auth.updateProfile && (await auth.updateProfile({ username, firstName, lastName, language, phone, address, photo, oldPassword, newPassword }));
		// }

		setLoading(false)
		setValues({
			...values,
        	errorMessages: [],
			successMessages: ['Profile Updated Successfully!!'],
		});
    } catch (error) {
      setLoading(false)
      setValues({
        ...values,
        errorMessages: [error.message],
        successMessages: [],
      });
    }
  };

  	const uploadPhoto = async(file) => {
		AWS.config.update(Config.AWSConfigExport);
		
		var fileName = file.name.split(/[.]+/);
		delete fileName[fileName.length - 1];
		fileName = fileName.join("_");
		var fileExt = file.name.split(/[.]+/).pop();

		const params = ({
			Bucket: 'user-pool-upload-photo',
			Key: fileName + Date.now() + '.' + fileExt,
			Body: file
		})

		const client = new S3Client({
			region: 'us-east-1',
			credentials: {
					accessKeyId: "AKIAUU2LLKYXYHJSNERO",
					secretAccessKey: "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"
				}
		});
		const command = new PutObjectCommand(params);
		const url = await getSignedUrl(client, command, { expiresIn: 3600 });
		console.log(url);

		const response = await fetch(url, { method: "PUT", body: file });
		console.log(response);

		const imageURL = url.split('?')[0];
		console.log(imageURL);
		return imageURL;
		/*
		https://user-pool-upload-photo.s3.us-east-1.amazonaws.com/Random_Image_Name1?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Content-Sha256=UNSIGNED-PAYLOAD&X-Amz-Credential=AKIAUU2LLKYXYHJSNERO%2F20220922%2Fus-east-1%2Fs3%2Faws4_request&X-Amz-Date=20220922T102901Z&X-Amz-Expires=3600&X-Amz-Signature=d8bc265d0ae620f6398011c72caa833698571fc80b70932993eb1dc8fdc75257&X-Amz-SignedHeaders=content-length%3Bhost&x-id=PutObject

		https://user-pool-upload-photo.s3.us-east-1.amazonaws.com/Random_Image_Name1
		*/
 	}

  return (
  	<MessageContainer
			render={({ messages, setMessages, resetSession, useOldSession }) => (
				<>
					<div>
						{auth && auth.hasValidSession ? <Header resetSession={resetSession} /> : <Container> <div className="navigation"><Navbar collapseOnSelect expand="lg" className="p-0 d-flex justify-content-start navbar-expand">
							<Navbar.Brand className="">
								{<Nav.Link href="/"> <svg width="67" height="23" viewBox="0 0 67 23" fill="none" xmlns="http://www.w3.org/2000/svg">
									<path d="M0.56 11.4C0.56 10.2533 0.773333 9.24667 1.2 8.38C1.64 7.51333 2.23333 6.84667 2.98 6.38C3.72667 5.91333 4.56 5.68 5.48 5.68C6.26667 5.68 6.95333 5.84 7.54 6.16C8.14 6.48 8.6 6.9 8.92 7.42V5.84H12.34V17H8.92V15.42C8.58667 15.94 8.12 16.36 7.52 16.68C6.93333 17 6.24667 17.16 5.46 17.16C4.55333 17.16 3.72667 16.9267 2.98 16.46C2.23333 15.98 1.64 15.3067 1.2 14.44C0.773333 13.56 0.56 12.5467 0.56 11.4ZM8.92 11.42C8.92 10.5667 8.68 9.89333 8.2 9.4C7.73333 8.90667 7.16 8.66 6.48 8.66C5.8 8.66 5.22 8.90667 4.74 9.4C4.27333 9.88 4.04 10.5467 4.04 11.4C4.04 12.2533 4.27333 12.9333 4.74 13.44C5.22 13.9333 5.8 14.18 6.48 14.18C7.16 14.18 7.73333 13.9333 8.2 13.44C8.68 12.9467 8.92 12.2733 8.92 11.42ZM21.0342 14.1V17H19.2942C18.0542 17 17.0876 16.7 16.3942 16.1C15.7009 15.4867 15.3542 14.4933 15.3542 13.12V8.68H13.9942V5.84H15.3542V3.12H18.7742V5.84H21.0142V8.68H18.7742V13.16C18.7742 13.4933 18.8542 13.7333 19.0142 13.88C19.1742 14.0267 19.4409 14.1 19.8142 14.1H21.0342ZM24.6392 4.68C24.0392 4.68 23.5459 4.50667 23.1592 4.16C22.7859 3.8 22.5992 3.36 22.5992 2.84C22.5992 2.30667 22.7859 1.86667 23.1592 1.52C23.5459 1.16 24.0392 0.979999 24.6392 0.979999C25.2259 0.979999 25.7059 1.16 26.0792 1.52C26.4659 1.86667 26.6592 2.30667 26.6592 2.84C26.6592 3.36 26.4659 3.8 26.0792 4.16C25.7059 4.50667 25.2259 4.68 24.6392 4.68ZM26.3592 18.44C26.3592 19.8133 26.0126 20.8 25.3192 21.4C24.6259 22.0133 23.6592 22.32 22.4192 22.32H21.0792V19.42H21.8992C22.2726 19.42 22.5392 19.3467 22.6992 19.2C22.8592 19.0533 22.9392 18.8133 22.9392 18.48V5.84H26.3592V18.44ZM32.2381 7.42C32.5581 6.9 33.0181 6.48 33.6181 6.16C34.2181 5.84 34.9048 5.68 35.6781 5.68C36.5981 5.68 37.4315 5.91333 38.1781 6.38C38.9248 6.84667 39.5115 7.51333 39.9381 8.38C40.3781 9.24667 40.5981 10.2533 40.5981 11.4C40.5981 12.5467 40.3781 13.56 39.9381 14.44C39.5115 15.3067 38.9248 15.98 38.1781 16.46C37.4315 16.9267 36.5981 17.16 35.6781 17.16C34.8915 17.16 34.2048 17.0067 33.6181 16.7C33.0315 16.38 32.5715 15.96 32.2381 15.44V17H28.8181V2.2H32.2381V7.42ZM37.1181 11.4C37.1181 10.5467 36.8781 9.88 36.3981 9.4C35.9315 8.90667 35.3515 8.66 34.6581 8.66C33.9781 8.66 33.3981 8.90667 32.9181 9.4C32.4515 9.89333 32.2181 10.5667 32.2181 11.42C32.2181 12.2733 32.4515 12.9467 32.9181 13.44C33.3981 13.9333 33.9781 14.18 34.6581 14.18C35.3381 14.18 35.9181 13.9333 36.3981 13.44C36.8781 12.9333 37.1181 12.2533 37.1181 11.4ZM47.4723 17.16C46.379 17.16 45.3923 16.9267 44.5123 16.46C43.6457 15.9933 42.959 15.3267 42.4523 14.46C41.959 13.5933 41.7123 12.58 41.7123 11.42C41.7123 10.2733 41.9657 9.26667 42.4723 8.4C42.979 7.52 43.6723 6.84667 44.5523 6.38C45.4323 5.91333 46.419 5.68 47.5123 5.68C48.6057 5.68 49.5923 5.91333 50.4723 6.38C51.3523 6.84667 52.0457 7.52 52.5523 8.4C53.059 9.26667 53.3123 10.2733 53.3123 11.42C53.3123 12.5667 53.0523 13.58 52.5323 14.46C52.0257 15.3267 51.3257 15.9933 50.4323 16.46C49.5523 16.9267 48.5657 17.16 47.4723 17.16ZM47.4723 14.2C48.1257 14.2 48.679 13.96 49.1323 13.48C49.599 13 49.8323 12.3133 49.8323 11.42C49.8323 10.5267 49.6057 9.84 49.1523 9.36C48.7123 8.88 48.1657 8.64 47.5123 8.64C46.8457 8.64 46.2923 8.88 45.8523 9.36C45.4123 9.82667 45.1923 10.5133 45.1923 11.42C45.1923 12.3133 45.4057 13 45.8323 13.48C46.2723 13.96 46.819 14.2 47.4723 14.2ZM61.3467 14.1V17H59.6067C58.3667 17 57.4001 16.7 56.7067 16.1C56.0134 15.4867 55.6667 14.4933 55.6667 13.12V8.68H54.3067V5.84H55.6667V3.12H59.0867V5.84H61.3267V8.68H59.0867V13.16C59.0867 13.4933 59.1667 13.7333 59.3267 13.88C59.4867 14.0267 59.7534 14.1 60.1267 14.1H61.3467ZM64.8517 17.16C64.2517 17.16 63.7584 16.9867 63.3717 16.64C62.9984 16.28 62.8117 15.84 62.8117 15.32C62.8117 14.7867 62.9984 14.34 63.3717 13.98C63.7584 13.62 64.2517 13.44 64.8517 13.44C65.4384 13.44 65.9184 13.62 66.2917 13.98C66.6784 14.34 66.8717 14.7867 66.8717 15.32C66.8717 15.84 66.6784 16.28 66.2917 16.64C65.9184 16.9867 65.4384 17.16 64.8517 17.16Z" fill="#333333" />
								</svg> </Nav.Link>}
							</Navbar.Brand></Navbar></div></Container>}
						<div className="">
							<div className="app-main">
								<div className="app-main-inner mrt-40">
									<Container style={{
										paddingTop: 30,
										paddingBottom: 30,
									}}>
									    <div className="login-page profilePage table-responsive">
									      <div className="login">     
									        <form className={classes.container} noValidate autoComplete="off" onKeyDown={inputOnKeyDown}> 

										        {values.errorMessages &&
										          values.errorMessages.map(
										          (err, i) => !!err && <div className = "alert alert-danger w-100"> {err} </div>,
										        )}

										         {values.successMessages &&
										          values.successMessages.map(
										          (success, i) => !!success && <div className = "alert alert-success w-100"> {success} </div>,
										        )}
  
									        	<Grid container spacing={2}>
										        	<Grid item xs={12} sm={6} md={6}>       
											          <label className={classes.label}>{translations.Full_Name}</label>
											          <Input
											          	type='text'
											            placeholder="eg: Tony Stark"
											            className={classes.textField}
											            value={values.firstName}
											            onChange={e => {
											              setValues({ ...values, firstName: e.target.value });
											            }}
											          />
											        </Grid>
											        <Grid item xs={12} sm={6} md={6}>    
											          <label className={classes.label}>{translations.Phone_number}</label>
											          <Input
											          	type='number'
											            placeholder="999-999-9999"
											            className={classes.textField}
											            value={values.phone}
											            onChange={e => {
											              setValues({ ...values, phone: e.target.value });
											            }}
											          />
											        </Grid>
											        <Grid item xs={12} sm={6} md={6}>    
											          <label className={classes.label}>{translations.Address}</label>
											          <Input
											          	type='text'
											            placeholder="eg: 105 Main St. British Columbia, CA 10001"
											            className={classes.textField}
											            value={values.address}
											            onChange={e => {
											              setValues({ ...values, address: e.target.value });
											            }}
											          />
											        </Grid>
											        <Grid item xs={12} sm={2} md={2}>  
											          <label className={classes.label}>{translations.Language}</label>
											          <select className={`myInput ${classes.textField}`} style={{ padding: '10px' }} defaultValue={language} onChange={(e) => setLanguage(e.target.value)}>
											            <option value="en">English</option>
											            <option value="es">Spanish</option>
											          </select>
											        </Grid>
											        <Grid item xs={12} sm={4} md={4}>    
											          <label className={classes.label}>{translations.Photo}</label>
											          <Input
											          	type='file'
											            className={`${classes.textField}`}
											            inputProps={{ accept: 'image/*' }}
											            onChange={e => {
											            	setFileObject((e.target as HTMLInputElement).files[0]);
											            }}
											          />
													  <img src={values.photo} style={{width: '30%', float:'right', position: 'relative', top: '-55px', display: values.photo != '' ? 'inherit' : 'none'}}/>
											        </Grid>
											        <Grid item xs={12} sm={6} md={6}>  
											          <label className={classes.label}>{translations.Old_password}</label>
											          <Input
											            placeholder="••••••••"
											            type='password'
											            className={`myInput ${classes.passField}`}
											            value={values.oldpassword}
											            onChange={e => {
											              setValues({ ...values, oldpassword: e.target.value });
											            }}
											          />
											        </Grid>
											        <Grid item xs={12} sm={6} md={6}>  
											          <label className={classes.label}>{translations.New_password}</label>
											          <Input
											            placeholder="••••••••"
											            type='password'
											            className={`myInput ${classes.passField}`}
											            value={values.newpassword}
											            onChange={e => {
											              setValues({ ...values, newpassword: e.target.value });
											            }}
											          />
											        </Grid>
											        {/*<Grid item xs={12} sm={4} md={4}>  
											          <label className={classes.label}>Confirm Password</label>
											          <Input
											            placeholder="••••••••"
											            type='password'
											            className={`myInput ${classes.passField}`}
											            value={values.confirmpassword}
											            onChange={e => {
											              setValues({ ...values, confirmpassword: e.target.value });
											            }}
											          />
											        </Grid>*/}
											    </Grid>
									          <div className="signUpBtn mt-30">
									            <Button
									              onClick={handleProfileUpdate}
									              variant="contained"
									              color="primary"
									              className={classes.button}
									            >
									              {loading ? 'Loading...' : translations.Update_Profile}
									            </Button>
									          </div>
									        </form>        
									      </div>
									    </div>
									</Container>
								</div>
							</div>
						</div>
						<Footer />
					</div>
				</>
			)}
		/>
  	);
};
